import {
  success50,
  success700,
  secondary50,
  secondary500,
  netural50,
  netural400,
} from "../../constants/color";

const STATUS_COLORS = {
  Active: { backgroundColor: success50, color: success700 },
  Scheduled: { backgroundColor: secondary50, color: secondary500 },
  Completed: { backgroundColor: netural50, color: netural400 },
};

const StatusBadge = ({ status, customColors }) => {
  const colors = customColors || STATUS_COLORS[status] || STATUS_COLORS.Completed;

  return (
    <span
      style={{
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        padding: "4px 12px",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
